import path from 'node:path'
import { filesDir } from './files-dir.js'

export function snapshotFilePath(cwd: string, scope: string, filePath: string): string {
  return path.join(filesDir(cwd, scope), ...filePath.split('/'))
}
